import { RoleSlug } from '@askporter/client-grieg-lyric';
import { AllRoles, ManagerRoles, UserProfilePageRefs } from '../../types';

export const userProfilePagesVisibility: Record<UserProfilePageRefs, Array<RoleSlug>> = {
  global_preferences: [...ManagerRoles, RoleSlug.SvcusrSpr, RoleSlug.SuppSpr],
  login_security: [...ManagerRoles, RoleSlug.SuppSpr, RoleSlug.SvcusrSpr],
  notifications_preferences: [...ManagerRoles, RoleSlug.SuppSpr, RoleSlug.SvcusrSpr],
  personal_details: AllRoles,
};
